import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { PaginationDefaults } from '../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { WebGameResponseDto } from '../dtos/web-game-response.dto';
import { WebGameResponseModel } from '../models/web-game-response.model';
import { mapWebGameResponseDtoToWebGameResponseModel } from '../utils/mapping.util';
import { WebGameHeaderFiltersAndPaginationModel } from './models/web-game-header-filters-and-pagination.model';

export const getWebGames: AsyncThunk<
  WebGameResponseModel[],
  Partial<WebGameHeaderFiltersAndPaginationModel> | undefined,
  Record<string, unknown>
> = createAsyncThunk('web-game/get-web-games', async filters => {
  const queryParams = createQueryParams({
    ...filters?.header,
    size: filters?.pagination?.size
      ? filters.pagination.size
      : PaginationDefaults.size,
    offset: filters?.pagination?.offset
      ? filters.pagination.offset
      : PaginationDefaults.offset,
  });

  const { data }: AxiosResponse<WebGameResponseDto[]> = await axiosInstance.get(
    Endpoints.WEB_GAMES + queryParams
  );

  return data.map(mapWebGameResponseDtoToWebGameResponseModel);
});
